/** Small formatting helpers shared by modes that show a clock. Moved here from `apps/client` in phase 03 — every mode using it now lives in this package. */

/**
 * A time to the tenth of a second: `93450` -> `"1:33.5"`, `5250` -> `"5.3s"`,
 * `700` -> `"0.7s"`. From a minute the seconds take two digits (`"1:05.0"`);
 * under a minute the time is written as plain seconds, with no leading `0:`
 * and no padding zero (`"0.7s"`, not `"00.7s"`).
 *
 * Rounded once, to whole tenths, before it is split into minutes and seconds,
 * so a time just under a minute that rounds up reads `"1:00.0"`, never
 * `"60.0s"` (nor `"1:60.0"` at two minutes).
 */
export function formatClock(ms: number): string {
  const tenths = Math.round(Math.max(0, ms) / 100);
  const minutes = Math.floor(tenths / 600);
  const secondTenths = tenths - minutes * 600;
  const secondsText = `${String(Math.floor(secondTenths / 10))}.${String(secondTenths % 10)}`;
  return minutes > 0 ? `${String(minutes)}:${secondsText.padStart(4, '0')}` : `${secondsText}s`;
}
